/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Undo_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Toolbar_Secondary_Undo_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_undo_aria_label = /** @type {((inputs?: Toolbar_Secondary_Undo_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Undo_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückgängig machen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disfare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deshacer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("撤销")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ववत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desfazer")
	return /** @type {LocalizedString} */ ("Undo")
});